import { GetTimezoneOffset, MerchantId, SetHeaderService } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import service from "../baseHttpService";

class CustomDashboardService {
  DoCreateCustomDashboard(customDashboardTemplate: any) {
    const _input = {
      merchantId: MerchantId(),
      customDashboardTemplate: customDashboardTemplate,
    };
    return service.peakRealTimeAPI
      .post("/api/CustomDashboard/CreateCustomDashboard", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
  DoUpdateCustomDashboard(customDashboardTemplate: any) {
    const _input = {
      merchantId: MerchantId(),
      customDashboardTemplate: customDashboardTemplate,
    };
    return service.peakRealTimeAPI
      .post("/api/CustomDashboard/UpdateCustomDashboard", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
  DoGetCustomDashboardDetail(customDashboardId: number) {
    const _input = {
      merchantId: MerchantId(),
      customDashboardId: customDashboardId,
    };
    return service.peakRealTimeAPI
      .post("/api/CustomDashboard/GetCustomDashboardDetail", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
  DoUpdateCustomDashboardGroup(input: any) {
    const _input = {
      merchantId: MerchantId(),
      customDashboardId: input.customDashboardId,
      customDashboardGroup: input.customDashboardGroup,
    };
    return service.peakRealTimeAPI
      .post("/api/CustomDashboard/UpdateCustomDashboardGroup", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
  DoGetCustomDashboardList(isUseMainDatabase: boolean) {
    const _input = {
      merchantId: MerchantId(),
      isUseMainDatabase: isUseMainDatabase,
    };
    return service.peakExportAPI
      .post("/api/CustomDashboard/GetCustomDashboardList", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
  DoGetSuggestionCustomDashboardNumber() {
    const _input = {
      merchantId: MerchantId(),
    };
    return service.peakRealTimeAPI
      .post("/api/CustomDashboard/GetSuggestionCustomDashboardNumber", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
  DoUpdateCustomDashboardIsDelete(customDashboardId: number) {
    const _input = {
      merchantId: MerchantId(),
      customDashboardId: customDashboardId,
    };
    return service.peakRealTimeAPI
      .post("/api/CustomDashboard/UpdateCustomDashboardIsDelete", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
  DoGetAllocationDashBoardDetail(input: any) {
    const _input = {
      merchantId: MerchantId(),
      customDashBoardId: input.customDashboardId,
      dashboardSelectOptionType: input.dashboardSelectOptionType,
      date: new Date().ToDateJsonString(),
      fromDate: input.fromDate,
      toDate: input.toDate,
    };
    return service.peakExportAPI
      .post("/api/CustomDashboard/GetAllocationDashBoardDetail", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
  DoGetAllocationDashBoardCompare(input: any) {
    const _input = {
      merchantId: MerchantId(),
      customDashBoardId: input.customDashboardId,
      dashboardSelectOptionType: input.dashboardSelectOptionType,
      date: new Date().ToDateJsonString(),
      fromDate: input.fromDate,
      toDate: input.toDate,
    };
    return service.peakExportAPI
      .post("/api/CustomDashboard/GetAllocationDashBoardCompare", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
  DoGetExportAllocationDashBoardDetail(input: any) {
    const _input = {
      merchantId: MerchantId(),
      timezoneOffset: GetTimezoneOffset(),
      customDashBoardId: input.customDashboardId,
      dashboardSelectOptionType: input.dashboardSelectOptionType,
      date: new Date().ToDateJsonString(),
      fromDate: input.fromDate,
      toDate: input.toDate,
      language: i18n.locale,
    };
    return service.peakExportAPI
      .post("/api/CustomDashboard/GetExportAllocationDashBoardDetail", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
  DoGetExportAllocationDashBoardCompare(input: any) {
    const _input = {
      merchantId: MerchantId(),
      timezoneOffset: GetTimezoneOffset(),
      customDashBoardId: input.customDashboardId,
      dashboardSelectOptionType: input.dashboardSelectOptionType,
      date: new Date().ToDateJsonString(),
      fromDate: input.fromDate,
      toDate: input.toDate,
      language: i18n.locale,
    };
    return service.peakExportAPI
      .post("/api/CustomDashboard/GetExportAllocationDashBoardCompare", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
  DoGetExportAllocationDashBoardCompareMockup(input: any) {
    const _input = {
      merchantId: MerchantId(),
      timezoneOffset: GetTimezoneOffset(),
      dashboardSelectOptionType: input.dashboardSelectOptionType,
      date: new Date().ToDateJsonString(),
      fromDate: input.fromDate,
      toDate: input.toDate,
      language: i18n.locale,
    };
    return service.peakExportAPI
      .post("/api/CustomDashboard/GetExportAllocationDashBoardCompareMockup", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
  DoGetExportAllocationDashBoardDetailMockup(input: any) {
    const _input = {
      merchantId: MerchantId(),
      timezoneOffset: GetTimezoneOffset(),
      dashboardSelectOptionType: input.dashboardSelectOptionType,
      date: new Date().ToDateJsonString(),
      fromDate: input.fromDate,
      toDate: input.toDate,
      language: i18n.locale,
    };
    return service.peakExportAPI
      .post("/api/CustomDashboard/GetExportAllocationDashBoardDetailMockup", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
}

export default new CustomDashboardService();
